import './CookiePrompt.scss'

import { HDSButton, HDSIcon } from '@here/hds-react-components'
import { getFaqLocalizedLink } from 'lib/faq'
import { i18n } from 'lib/i18n'
import React from 'react'

export interface CookiePromptProps {
  clickRejected: () => void
  clickAccepted: () => void
}

export default function CookiePrompt({
  clickAccepted,
  clickRejected,
}: CookiePromptProps): JSX.Element {
  const hdsIconStyle = {
    '--hds-icon-color': 'var(--hds-foreground-primary)',
  } as React.CSSProperties

  const accept = i18n('cookie.prompt.accept.button')
  const content = i18n('cookie.prompt.body')
  const decline = i18n('cookie.prompt.decline.button')
  const link = i18n('cookie.prompt.link')
  const title = i18n('cookie.prompt.title')
  const { cookie } = getFaqLocalizedLink()

  return (
    <div className="CookiePrompt">
      <div className="CookiePrompt__header">
        <HDSIcon
          name="handshake"
          category="misc"
          style={hdsIconStyle}
          iconStyle="solid"
          size="24"
        />
        <div className="CookiePrompt__header-title">{title}</div>
      </div>
      <div className="CookiePrompt__content">
        <span className="CookiePrompt__message">{content}</span>
        <a className="CookiePrompt__link" href={cookie}>
          {link}
        </a>
      </div>
      <div className="CookiePrompt__footer">
        <HDSButton
          className="CookiePrompt__action-btn"
          onClick={clickAccepted}
          size="medium"
          type="button"
          variant="primary"
          width="100%"
        >
          {accept}
        </HDSButton>
        <HDSButton
          className="CookiePrompt__action-btn"
          onClick={clickRejected}
          size="small"
          type="button"
          variant="link"
          width="100%"
        >
          {decline}
        </HDSButton>
      </div>
    </div>
  )
}
